var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { createRef } from 'react';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';
import { withRouter } from 'react-router-dom';
import { SignalREvents } from '@app/AppConstants';
import { signalRService } from '@app/Services/SignalRService';
import { ApprovedChecklistStatusOverview, CheckListStatusOverviewColumnName } from '../GatePreparations/ApprovedGateView/ApprovedChecklistView/ApprovedChecklistStatusOverview/ApprovedChecklistStatusOverview';
import { GateTabsWrapper } from '@app/Components/GateTabsWrapper/GateTabsWrapper';
import { MeetingMilestoneGateView } from './MeetingMilestoneGateView';
var MilestoneGateMeetingsC = /** @class */ (function (_super) {
    __extends(MilestoneGateMeetingsC, _super);
    function MilestoneGateMeetingsC() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._wrapper = createRef();
        _this._checklistStatusOverview = React.createRef();
        _this.refreshChecklistStatusOverview = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ((_a = this._checklistStatusOverview.current) === null || _a === void 0 ? void 0 : _a.refreshChecklistStatusOverview())];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    MilestoneGateMeetingsC.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                signalRService.subscribe(SignalREvents.decisionChanged, this._loadGates);
                signalRService.subscribe(SignalREvents.recommendationChanged, this._loadGates);
                return [2 /*return*/];
            });
        });
    };
    MilestoneGateMeetingsC.prototype.componentWillUnmount = function () {
        signalRService.unsubscribe(SignalREvents.decisionChanged, this._loadGates);
        signalRService.unsubscribe(SignalREvents.recommendationChanged, this._loadGates);
    };
    MilestoneGateMeetingsC.prototype._loadGates = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._wrapper.current) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._wrapper.current.updateGates()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    MilestoneGateMeetingsC.prototype._getGates = function () {
        if (this._wrapper.current) {
            return this._wrapper.current.getGates();
        }
        return [];
    };
    MilestoneGateMeetingsC.prototype.onChangeGate = function (gate) {
        this._currentGate = gate;
    };
    MilestoneGateMeetingsC.prototype.render = function () {
        var _a = this.props, projectId = _a.projectId, match = _a.match, projectState = _a.projectState, projectType = _a.projectType, location = _a.location, projectCodeName = _a.projectCodeName, isProjectTerminatedOrCompleted = _a.isProjectTerminatedOrCompleted;
        return (React.createElement(React.Fragment, null,
            React.createElement(GateTabsWrapper, { ref: this._wrapper, projectState: projectState, projectType: projectType, projectId: projectId, match: match, location: location, needToShowMeetingButton: true, onChangeCurrentGateHandler: this.onChangeGate }, this._currentGate ? (React.createElement(React.Fragment, null,
                React.createElement(ApprovedChecklistStatusOverview, { ref: this._checklistStatusOverview, checklistId: this._currentGate.masterCheckListId, hideColumns: [
                        CheckListStatusOverviewColumnName.FunctionRating,
                        CheckListStatusOverviewColumnName.AssessorRating
                    ], isForGateMeeting: true }),
                React.createElement(MeetingMilestoneGateView, { gate: this._currentGate, projectCodeName: projectCodeName, meetingGates: this._getGates(), projectId: this.props.projectId, projectState: projectState, projectType: projectType, onRefresh: this._loadGates, onRefreshChecklistStatusOverview: this.refreshChecklistStatusOverview, isProjectTerminatedOrCompleted: isProjectTerminatedOrCompleted }))) : null)));
    };
    __decorate([
        observable
    ], MilestoneGateMeetingsC.prototype, "_currentGate", void 0);
    __decorate([
        observable
    ], MilestoneGateMeetingsC.prototype, "_wrapper", void 0);
    __decorate([
        action.bound
    ], MilestoneGateMeetingsC.prototype, "_loadGates", null);
    __decorate([
        action.bound
    ], MilestoneGateMeetingsC.prototype, "onChangeGate", null);
    MilestoneGateMeetingsC = __decorate([
        observer
    ], MilestoneGateMeetingsC);
    return MilestoneGateMeetingsC;
}(React.PureComponent));
export var MilestoneGateMeetings = withRouter(MilestoneGateMeetingsC);
